<template>
  <div>
    <section class="content">
      <div class="box info-box">
        <div class="box-header with-border">
          Search By
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-md-3" v-if="this.$store.state.user.type == 'admin'">
              <label for="Branch">Branch</label>
              <v-select v-model="branch" name="branch_id" label="name" :options="branches" v-on:input="branchRecordWithchangeFilter" placeholder="Select Branch"></v-select>
              <has-error
                :form="form"
                field="branch_id"
              ></has-error>
            </div>
            <div class="col-md-3" v-if="user.type == 'admin' && this.form.branch_id !== ''">
              <label for="Designation">Designation</label>
              <v-select v-model="designation" name="designation_id" label="name" :options="designations" placeholder="Select Designation" v-on:input="getRecordDesignationWise"></v-select>
              
              <has-error
                :form="form"
                field="designation_id"
              ></has-error>
            </div>
            <!-- <div class="col-sm-3">
              <div class="form-group">
                <label
                  >Select Status <span class="red">*</span></label
                >
                <select
                  v-model="form.status"
                  name="status"
                  class="form-control"
                  @change="changeFilter"
                  :class="{
                    'is-invalid': form.errors.has('status'),
                  }"
                >
                  <option v-if="!form.status" selected value="">
                    Select Status
                  </option>
                  <option value="">All</option>
                  <option value="pending">Pending</option>
                  <option value="verified">Verified</option>
                  <option value="reject">Reject</option>
                </select>
                <has-error :form="form" field="status"></has-error>
              </div>
            </div> -->
          </div>
        </div>
        <!-- /.box-body -->
      </div>
      <!-- Default box -->
      <!-- <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Employee List</h3>
           <span class="float-right">
              <button
                v-if="canAccess('staff-create')"
                type="button"
                class="btn btn-success"
                @click="newModal"
              >
                <i class="fa fa-plus"></i>
              </button>
            </span>         
          
          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
              <i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove" data-toggle="tooltip" title="" data-original-title="Remove">
              <i class="fa fa-times"></i></button>
          </div>
        </div>
        <div class="box-body">
          <vue-good-table
            :columns="columns"
            :rows="rows"
            styleClass="vgt-table condensed"
            :line-numbers="true"
            :pagination-options="{
              enabled: true,
              perPage: 10,
              perPageDropdown: [10, 20, 30],
            }"
            :search-options="{
              enabled: true,
              trigger: 'enter',
            }"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'id'">
                <button
                  v-if="canAccess('staff-view')"
                  @click="viewModal(props.row)"
                  class="btn btn-info btn-xs"
                >
                  <i class="fa fa-eye"></i>
                </button>
                <button
                  v-if="canAccess('staff-view')"
                  @click="verifyModal(props.row)"
                  class="btn btn-danger btn-xs"
                  title="Verify"
                >
                  <i class="fa fa-check-square"></i>
                </button>
                <button
                  v-if="canAccess('staff-update')"
                  @click="editModal(props.row)"
                  class="btn btn-success btn-xs"
                >
                  <i class="fa fa-pencil"></i>
                </button>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
        <div class="box-footer">
          List of all Employee
        </div>
      </div> -->
      <!-- /.box -->
      
      <!-- Default box -->
      <div class="info-box"  v-if="canAccess('staff-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Staff List</h3>
          
          <div class="box-tools">
            <a :href="`${this.$axios.defaults.baseURL}/staff/export/excel`" class="btn btn-box-tool" v-if="canAccess('staff-create')">
              <i class="fa fa-file-excel-o"></i> Download Excel
            </a>
            <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('staff-create')">
              <i class="fa fa-plus"></i> Add New
            </button>
          </div>

        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
                <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
            <div class="col-sm-6 col-xs-6">
              <div class="input-group pull-right input-group-sm" style="width: 150px;">
                <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search by Name">

                <div class="input-group-btn">
                  <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-sm table-bordered table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th class="hidden-xs">Sr.</th>
                <th>Code </th>
                <th>Name</th>
                <th>Email</th>
                <th>Alias</th>
                <th>Designation</th>
                <th>Mobile</th>
                <th class="hidden-xs">Branch</th>
                <th class="hidden-xs">KYC Status</th>
                <th class="hidden-xs">Login Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rows" :key="index">
                <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                <td>{{ row.user.code }}</td>
                <td>{{ row.user.name }}</td>
                <td>{{ row.user.email }}</td>
                <td>{{ row.user.alias }}</td>
                <td>{{ row.designation.name }}</td>
                <td><i class="fa fa-check-circle-o text-success" v-show="row.user.mobileVerify == 'true'"></i> {{row.user.mobile}}</td>
                <td class="hidden-xs">{{ row.branch.name }}</td>
                <td class="hidden-xs">{{ row.status }}</td>
                <td class="hidden-xs">{{ row.user.status }}</td>
                <!-- <td class="hidden-xs">
                  <div v-if="row.status == 'active'">
                    <span class="label label-success">Active</span>
                  </div>
                  <div v-else>
                    <span class="label label-danger">InActive</span>
                  </div>
                </td> -->
                <td>
                  <div class="btn-group">
                    <button
                        v-if="canAccess('staff-view')"
                        @click="viewModal(row)"
                        class="btn btn-info btn-xs"
                      >
                        <i class="fa fa-eye"></i>
                    </button>
                    <button
                      v-if="canAccess('staff-update')"
                      @click="editModal(row)"
                      class="btn btn-success btn-xs"
                    >
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button
                      v-if="canAccess('staff-delete')"
                      @click="loginStatus(row)"
                      title="Check Login Status"
                      class="btn btn-warning btn-xs"
                    >
                      <i class="fa fa-sign-in"></i>
                    </button>
                    <button
                        v-if="canAccess('staff-view')"
                        @click="viewIdCardPrintModal(row)"
                        class="btn btn-info btn-xs"
                      >
                        <i class="fa fa-user"></i>
                    </button>
                    <button
                      v-if="canAccess('staff-verify')"
                      @click="verifyModal(row)"
                      class="btn btn-danger btn-xs"
                      title="Verify"
                    >
                      <i class="fa fa-check-square"></i>
                    </button>
                    
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /.box -->
    </section>


        <div class="modal fade" id="newModal">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-aqua">
                
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 v-show="!editMode" class="modal-title">Add New Employee</h4>
                <h4 v-show="editMode" class="modal-title">Edit Employee</h4>
              </div>
              <form
                @submit.prevent="editMode ? updateEmployee() : createEmployee()"
              >
                <div class="modal-body">
                  <!-- right column -->
                    <!-- general form elements disabled -->
                    <div class="card card-warning">
                      <!-- /.card-header -->
                      <div class="card-body">
                        <div class="row">
                          <div class="col-sm-4">
                            <!-- text input -->
                            <div class="form-group">
                              <label>Branch <span class="red">*</span></label>
                              <select
                                v-model="form.branch_id"
                                name="branch_id"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('branch_id'),
                                }"
                              >
                                <option
                                  v-if="!form.branch_id"
                                  selected
                                  value=""
                                >
                                  Select Company Branch
                                </option>
                                <option
                                  :value="branch.id"
                                  v-for="branch in branches"
                                  :key="branch.id"
                                >
                                  {{ branch.name }}
                                </option>
                              </select>
                              <has-error
                                :form="form"
                                field="branch_id"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label>Name <span class="red">*</span></label>
                              <input
                                v-model="form.name"
                                type="text"
                                name="name"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('name'),
                                }"
                                placeholder="Enter Employee Name"
                              />
                              <has-error :form="form" field="name"></has-error>
                            </div>
                            <div class="form-group">
                              <label>Name Alias</label>
                              <input
                                v-model="form.alias"
                                type="text"
                                name="alias"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('alias'),
                                }"
                                placeholder="Enter Employee Name"
                              />
                              <has-error :form="form" field="alias"></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Father Name<span class="red">*</span></label
                              >
                              <input
                                v-model="form.fatherName"
                                type="text"
                                name="fatherName"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('fatherName'),
                                }"
                                placeholder="Enter fatherName"
                              />
                              <has-error
                                :form="form"
                                field="fatherName"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label>DOB Date <span class="red">*</span></label>
                              <input
                                v-model="form.dob"
                                type="date"
                                name="dob"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('dob'),
                                }"
                                placeholder="Enter DOB"
                                required
                              />
                              <has-error :form="form" field="dob"></has-error>
                            </div>
                            <div class="form-group">
                              <label>Contact Email <span class="red">*</span></label>
                              <input
                                v-model="form.email"
                                type="email"
                                name="email"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('email'),
                                }"
                                placeholder="Enter email"
                              />
                              <has-error :form="form" field="email"></has-error>
                            </div>

                          </div>

                          <div class="col-sm-4">
                            <!-- text input -->
                            <div class="form-group">
                              <label
                                >Contact Number 1<span class="red"
                                  >*</span
                                ></label
                              >
                              <input
                                v-model="form.mobile"
                                type="text"
                                name="mobile"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('mobile'),
                                }"
                                placeholder="Enter mobile number"
                              />
                              <has-error
                                :form="form"
                                field="mobile"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label>Contact Number 2 </label>
                              <input
                                v-model="form.phone"
                                type="text"
                                name="phone"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('phone'),
                                }"
                                placeholder="Enter Alternative Number"
                              />
                              <has-error :form="form" field="phone"></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Designation <span class="red">*</span></label
                              >
                              <select
                                v-model="form.designation_id"
                                name="designation_id"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'designation_id'
                                  ),
                                }"
                              >
                                <option
                                  v-show="!form.designation_id"
                                  selected
                                  value=""
                                >
                                  Select Designation
                                </option>
                                <option v-show="designation.id != 3"
                                  :value="designation.id"
                                  v-for="designation in designations"
                                  :key="designation.id"
                                >
                                  {{ designation.name }}
                                </option>
                              </select>
                              <has-error
                                :form="form"
                                field="designation_id"
                              ></has-error>
                            </div>

                            <div class="form-group">
                              <label
                                >Staff Role <span class="red">*</span></label
                              >
                              <select
                                v-model="form.role_id"
                                name="role_id"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'role_id'
                                  ),
                                }"
                              >
                                <option
                                  v-show="!form.role_id"
                                  selected
                                  value=""
                                >
                                  Select Role
                                </option>
                                <option v-show="role.id != 3"
                                  :value="role.id"
                                  v-for="role in roles"
                                  :key="role.id"
                                >
                                  {{ role.name }}
                                </option>
                              </select>
                              <has-error
                                :form="form"
                                field="role_id"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Joining Date <span class="red">*</span></label
                              >
                              <input
                                v-model="form.joiningDate"
                                type="date"
                                name="joiningDate"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('joiningDate'),
                                }"
                                placeholder="Enter joining Date"
                                required
                              />
                              <has-error
                                :form="form"
                                field="joiningDate"
                              ></has-error>
                            </div>

                            <div class="form-group">
                              <label>Password <span class="red">*</span></label>
                              <input
                                v-model="form.password"
                                type="password"
                                name="password"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('password'),
                                }"
                                placeholder="Enter password"
                              />
                              <has-error :form="form" field="password"></has-error>
                            </div>
                            
                          </div>

                          <div class="col-sm-4">
                            
                            <div class="form-group">
                              <label>Address <span class="red">*</span></label>
                              <input
                                v-model="form.address"
                                type="text"
                                name="address"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('address'),
                                }"
                                placeholder="Enter address"
                              />
                              <has-error
                                :form="form"
                                field="address"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label>City <span class="red">*</span></label>
                              <input
                                v-model="form.city"
                                type="text"
                                name="city"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('city'),
                                }"
                                placeholder="Enter Employee city"
                              />
                              <has-error :form="form" field="city"></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Select State <span class="red">*</span></label
                              >
                              <select
                                v-model="form.state_id"
                                name="state_id"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('state_id'),
                                }"
                              >
                                <option v-if="!form.state_id" selected value="">
                                  Select State
                                </option>
                                <option
                                  :value="stat.id"
                                  v-for="stat in states"
                                  :key="stat.id"
                                >
                                  {{ stat.name }}
                                </option>
                              </select>
                              <has-error
                                :form="form"
                                field="state_id"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label>Pincode <span class="red">*</span></label>
                              <input
                                v-model="form.pin"
                                type="text"
                                name="pin"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('pin'),
                                }"
                                placeholder="Enter Employee pincode"
                              />
                              <has-error :form="form" field="pin"></has-error>
                            </div>

                            <div class="form-group">
                              <label
                                >Last Experience</label
                              >
                              <input
                                v-model="form.lastExperience"
                                type="text"
                                name="lastExperience"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'lastExperience'
                                  ),
                                }"
                                placeholder="Enter Last Experience"
                              />
                              <has-error
                                :form="form"
                                field="lastExperience"
                              ></has-error>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  <div class="col-md-12">
                    <h2>Bank Details</h2>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-4">
                          <!-- text input -->

                          <div class="form-group">
                            <label>Bank Account Number<span class="red">*</span></label>
                            <input
                              v-model="form.accountNumber"
                              type="text"
                              name="accountNumber"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('accountNumber'),
                              }"
                              placeholder="Enter Employee accountNumber"
                            />
                            <has-error
                              :form="form"
                              field="accountNumber"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label>Account Holder Name</label>
                            <input
                              v-model="form.accountHolderName"
                              type="text"
                              name="accountHolderName"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'accountHolderName'
                                ),
                              }"
                              placeholder="Enter Employee accountHolderName"
                            />
                            <has-error
                              :form="form"
                              field="accountHolderName"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label>Bank Name<span class="red">*</span></label>
                            <select
                              v-model="form.bank_id"
                              name="bank_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('bank_id'),
                              }"
                            >
                              <option v-if="!form.bank_id" selected value="">
                                Select Bank
                              </option>
                              <option
                                :value="bank.id"
                                v-for="bank in banks"
                                :key="bank.id"
                              >
                                {{ bank.name }}
                              </option>
                            </select>
                            <has-error :form="form" field="bank_id"></has-error>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <!-- text input -->

                          <div class="form-group">
                            <label>IFSC Code </label>
                            <input
                              v-model="form.ifsc"
                              type="text"
                              name="ifsc"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('ifsc') }"
                              placeholder="Enter Employee ifsc"
                            />
                            <has-error :form="form" field="ifsc"></has-error>
                          </div>
                          <div class="form-group">
                            <label
                              >Bank Branch </label
                            >
                            <input
                              v-model="form.bank_branch"
                              type="text"
                              name="bank_branch"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('bank_branch'),
                              }"
                              placeholder="Enter Employee bank_branch"
                            />
                            <has-error
                              :form="form"
                              field="bank_branch"
                            ></has-error>
                          </div>
                          
                        </div>
                        <div class="col-sm-4">
                          <!-- text input -->
                          <div class="form-group">
                            <label>Aadhar No </label>
                            <input
                              v-model="form.aadhar"
                              type="text"
                              name="aadhar"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('aadhar'),
                              }"
                              placeholder="Enter Employee aadhar"
                            />
                            <has-error :form="form" field="aadhar"></has-error>
                          </div>

                          <div class="form-group">
                            <label
                              >Pancard Number</label
                            >
                            <input
                              v-model="form.pan"
                              type="text"
                              name="pan"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('pan') }"
                              placeholder="Enter Employee pancard number"
                            />
                            <has-error :form="form" field="pan"></has-error>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="col-md-12">
                    <h2>Earning</h2>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">

                          <div class="form-group">
                            <label>Basic Salary(Annual)</label>
                            <input
                              v-model="form.basicSalary"
                              type="text"
                              name="basicSalary"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('basicSalary'),
                              }"
                              placeholder="Enter Employee basicSalary"
                            />
                            <has-error
                              :form="form"
                              field="basicSalary"
                            ></has-error>
                          </div>
                        </div>
                        <div class="col-sm-6">

                          <div class="form-group">
                            <label>Fixed Allowance</label>
                            <input
                              v-model="form.fixedAllowance"
                              type="text"
                              name="fixedAllowance"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('fixedAllowance'),
                              }"
                              placeholder="Enter Employee fixedAllowance"
                            />
                            <has-error
                              :form="form"
                              field="fixedAllowance"
                            ></has-error>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->

                  <!-- <div class="col-md-12">
                    <h2>Deduction</h2>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">

                          <div class="form-group">
                            <label>Fixed Deduction(in Month)</label>
                            <input
                              v-model="form.fixedDeduction"
                              type="text"
                              name="fixedDeduction"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('fixedDeduction'),
                              }"
                              placeholder="Enter Employee fixedDeductioncard number"
                            />
                            <has-error
                              :form="form"
                              field="fixedDeduction"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label>Number of Month for Fixed Deduction</label>
                            <input
                              v-model="form.numberOfMonthForFixedDeduction"
                              type="number"
                              name="numberOfMonthForFixedDeduction"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'numberOfMonthForFixedDeduction'
                                ),
                              }"
                              placeholder="Enter Employee numberOfMonthForFixedDeductioncard number"
                            />
                            <has-error
                              :form="form"
                              field="numberOfMonthForFixedDeduction"
                            ></has-error>
                          </div>
                        </div>
                        <div class="col-sm-6">

                          <div class="form-group">
                            <label>Income Tax(in Month)</label>
                            <input
                              v-model="form.incomeTax"
                              type="text"
                              name="incomeTax"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('incomeTax'),
                              }"
                              placeholder="Enter Employee incomeTaxcard number"
                            />
                            <has-error
                              :form="form"
                              field="incomeTax"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label>Number of Month Income Tax</label>
                            <input
                              v-model="form.numberOfMonthIncomeTax"
                              type="number"
                              name="numberOfMonthIncomeTax"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'numberOfMonthIncomeTax'
                                ),
                              }"
                              placeholder="Enter Employee numberOfMonthIncomeTaxcard number"
                            />
                            <has-error
                              :form="form"
                              field="numberOfMonthIncomeTax"
                            ></has-error>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->

                  <!-- <div class="col-md-12">
                    <h2>Annualy</h2>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-4">

                          <div class="form-group">
                            <label>Sick Leave(Annualy)</label>
                            <input
                              v-model="form.sickLeave"
                              type="number"
                              name="sickLeave"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('sickLeave'),
                              }"
                              placeholder="Enter Employee sickLeave"
                            />
                            <has-error
                              :form="form"
                              field="sickLeave"
                            ></has-error>
                          </div>

                          <div class="form-group">
                            <label>Casual Leaves (Annually)</label>
                            <input
                              v-model="form.casualLeave"
                              type="number"
                              name="casualLeave"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('casualLeave'),
                              }"
                              placeholder="Enter Employee casualLeave"
                            />
                            <has-error
                              :form="form"
                              field="casualLeave"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label>Extra Ordinary Leave</label>
                            <input
                              v-model="form.extraOrdinaryLeave"
                              type="number"
                              name="extraOrdinaryLeave"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'extraOrdinaryLeave'
                                ),
                              }"
                              placeholder="Enter Employee extraOrdinaryLeave"
                            />
                            <has-error
                              :form="form"
                              field="extraOrdinaryLeave"
                            ></has-error>
                          </div>
                        </div>
                        <div class="col-sm-4">

                          <div class="form-group">
                            <label>Previlage Leave</label>
                            <input
                              v-model="form.previlageLeave"
                              type="number"
                              name="previlageLeave"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('previlageLeave'),
                              }"
                              placeholder="Enter Employee previlageLeave"
                            />
                            <has-error
                              :form="form"
                              field="previlageLeave"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label>Paternity Leave</label>
                            <input
                              v-model="form.paternityLeave"
                              type="number"
                              name="paternityLeave"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('paternityLeave'),
                              }"
                              placeholder="Enter Employee paternityLeave"
                            />
                            <has-error
                              :form="form"
                              field="paternityLeave"
                            ></has-error>
                          </div>
                          
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label>Mandatory Leave</label>
                            <input
                              v-model="form.mandatoryLeave"
                              type="number"
                              name="mandatoryLeave"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('mandatoryLeave'),
                              }"
                              placeholder="Enter Employee mandatoryLeave"
                            />
                            <has-error
                              :form="form"
                              field="mandatoryLeave"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label>Maternity Leave</label>
                            <input
                              v-model="form.maternityLeave"
                              type="number"
                              name="maternityLeave"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('maternityLeave'),
                              }"
                              placeholder="Enter Employee maternityLeave"
                            />
                            <has-error
                              :form="form"
                              field="maternityLeave"
                            ></has-error>
                          </div>
 
                        </div>
                      </div>
                    </div>
                  </div> -->

                </div>
                <div class="modal-footer text-center">
                  <button
                    v-show="!editMode"
                    type="submit"
                    class="btn btn-success"
                  >
                    SAVE
                  </button>
                  <button
                    v-show="editMode"
                    type="submit"
                    class="btn btn-success"
                  >
                    UPDATE
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                  >
                    CANCEL
                  </button>
                </div>
              </form>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
        <div class="modal fade" id="loginStatus">
          <div class="modal-dialog modal-sm">
            <div class="modal-content">
              <div class="modal-header bg-aqua">
                
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Staff Login Status</h4>
              </div>
                <div class="modal-body">
                  <!-- right column -->
                  <div class="row" v-if="empInfo.user">
                    <div class="col-md-12">
                      <div class="card card-primary card-outline">
                        <div class="card-body box-profile">
                          <!-- <div class="text-center">
                            <img
                              class="profile-user-img img-fluid img-circle"
                              :src= this.photo
                              alt="User profile picture"
                            />
                          </div> -->

                          <h3 class="profile-username text-center">
                            {{ empInfo.user.name }} 
                          </h3>

                          <p class="text-muted text-center">
                            Code - {{empInfo.user.code}} <br>
                            Contact - 91-{{ empInfo.user.mobile }}
                          </p>
                        </div>
                        <!-- /.card-body -->
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="card card-warning">
                        <!-- /.card-header -->
                        <div class="card-body">
                          <div class="row" v-if="empInfo.user">
                            <div class="card-body box-profile">
                              <p><strong>Staff Login Status </strong></p>
                              <div class="form-group">  
                                <select
                                  v-model="form.status"
                                  name="status"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('status'),
                                  }"
                                  required
                                >
                                  <option v-if="!form.status" selected value="">
                                    Select Status
                                  </option>
                                  <option value="active">Active</option>
                                  <option value="inActive">Inactive</option>
                                  <option value="pending">Pending</option>
                                </select>
                                <has-error :form="form" field="status"></has-error>
                              </div>
                              <button @click="loginStaffStatus" class="btn btn-success btn-block"
                                ><b>Update Login Status</b></button
                              >
                                
                            </div>
                          </div>
                        </div>
                        <!-- /.card-body -->
                      </div>
                    <!-- /.card -->
                    </div>
                  </div>
                    <!-- general form elements disabled -->
                    
                 
                  <!--/.col (right) -->
                </div>
                <div class="modal-footer text-center">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                  >
                    CANCEL
                  </button>
                </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
        <div class="modal fade" id="verifyModal">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-aqua">
                
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Verify Employee Details</h4>
              </div>
              <form
                @submit.prevent="editMode ? updateEmployee() : createEmployee()"
              >
                <div class="modal-body">
                  <!-- right column -->
                  <div class="row" v-if="empInfo.user">
                    <div class="col-md-3">
                      <div class="card card-primary card-outline">
                        <div class="card-body box-profile">
                          <!-- <div class="text-center">
                            <img
                              class="profile-user-img img-fluid img-circle"
                              :src= this.photo
                              alt="User profile picture"
                            />
                          </div> -->

                          <h3 class="profile-username text-center">
                            {{ empInfo.user.name }} 
                          </h3>

                          <p class="text-muted text-center">
                            Code - {{empInfo.user.code}} <br>
                            Contact - 91-{{ empInfo.user.mobile }}
                          </p>

                          <ul class="list-group list-group-unbordered mb-3">
                            <li class="list-group-item">
                              <b>Login Status</b>
                              <a class="pull-right fa fa-check-circle-o text-success" v-if="empInfo.user.status == 'active'"></a>
                              <a class="pull-right fa fa-close text-danger" v-else></a>
                            </li>
                            <li class="list-group-item">
                              <b>KYC Status</b>
                              <a class="pull-right fa fa-check-circle-o text-success" v-if="empInfo.status == 'active'"></a>
                              <a class="pull-right fa fa-close text-danger" v-else></a>
                            </li>
                            <li class="list-group-item">
                              <b>Mobile Number Status</b>
                              <a class="pull-right fa fa-check-circle-o text-success" v-if="empInfo.user.mobileVerify == 'true'"></a>
                              <a class="pull-right fa fa-close text-danger" v-else></a>
                            </li>
                            <!-- <li class="list-group-item">
                              <b>Photo Status</b>
                              <a class="pull-right fa fa-check-circle-o text-success" v-if="empInfo.photoStatus == 'true'"></a>
                              <a class="pull-right fa fa-close text-danger" v-else></a>
                            </li> -->
                            <li class="list-group-item">
                              <b>Pancard Status</b>
                              <a class="pull-right fa fa-check-circle-o text-success" v-if="empInfo.panStatus == 'true'"></a>
                              <a class="pull-right fa fa-close text-danger" v-else></a>
                            </li>
                            <li class="list-group-item">
                              <b>Aadhar Status</b>
                              <a class="pull-right fa fa-check-circle-o text-success" v-if="empInfo.aadharStatus == 'true'"></a>
                              <a class="pull-right fa fa-close text-danger" v-else></a>
                            </li>
                          </ul>
                        </div>
                        <!-- /.card-body -->
                      </div>
                    </div>
                    <div class="col-md-9">
                      <div class="card card-warning">
                        <!-- /.card-header -->
                        <div class="card-body">
                          <div class="row">
                            <div class="col-sm-4">
                              <!-- text input -->
                              <div class="form-group">
                                <label>Aadhar No <span class="red">*</span></label>
                                <input
                                  v-model="form.aadhar"
                                  type="text"
                                  name="aadhar"
                                  class="form-control"
                                  disabled
                                  :class="{
                                    'is-invalid': form.errors.has('aadhar'),
                                  }"
                                  placeholder="Enter Employee aadhar"
                                />
                                <has-error :form="form" field="aadhar"></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  >Aadhar Status <span class="red">*</span></label
                                >
                                <select
                                  v-model="form.aadharStatus"
                                  name="aadharStatus"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('aadharStatus'),
                                  }"
                                >
                                  <option
                                    v-if="!form.aadharStatus"
                                    selected
                                    value=""
                                  >
                                    Select Aadhar Status
                                  </option>
                                  <option value="true">Active</option>
                                  <option value="false">Inactive</option>
                                </select>
                                <has-error
                                  :form="form"
                                  field="aadharStatus"
                                ></has-error>
                              </div>
                            
                            </div>

                            <div class="col-sm-4">
                              <!-- text input -->
                              <div class="form-group">
                                <label
                                  >Pancard Number <span class="red">*</span></label
                                >
                                <input
                                  v-model="form.pan"
                                  type="text"
                                  name="pan"
                                  class="form-control"
                                  disabled
                                  :class="{ 'is-invalid': form.errors.has('pan') }"
                                  placeholder="Enter Employee pancard number"
                                />
                                <has-error :form="form" field="pan"></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  >Pancard Status <span class="red">*</span></label
                                >
                                <select
                                  v-model="form.panStatus"
                                  name="panStatus"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('panStatus'),
                                  }"
                                >
                                  <option v-if="!form.panStatus" selected value="">
                                    Select Pancard Status
                                  </option>
                                  <option value="true">Active</option>
                                  <option value="false">Inactive</option>
                                </select>
                                <has-error
                                  :form="form"
                                  field="panStatus"
                                ></has-error>
                              </div>
                            </div>

                            <div class="col-sm-4">
                              
                              <div class="form-group">
                                <label
                                  >Select Reason <span class="red">*</span></label
                                >
                                <select
                                  v-model="form.reason_id"
                                  name="reason_id"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('reason_id'),
                                  }"
                                >
                                  <option v-if="!form.reason_id" selected value="">
                                    Select Reason
                                  </option>
                                  <option
                                    :value="reason.id"
                                    v-for="reason in reasons"
                                    :key="reason.id"
                                  >
                                    {{ reason.reason }}
                                  </option>
                                </select>
                                <has-error
                                  :form="form"
                                  field="reason_id"
                                ></has-error>
                              </div>
                              <!-- <div class="form-group">
                                <label
                                  >Select Status <span class="red">*</span></label
                                >
                                <select
                                  v-model="form.status"
                                  name="status"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('status'),
                                  }"
                                  required
                                >
                                  <option v-if="!form.status" selected value="">
                                    Select Status
                                  </option>
                                  <option value="active">Active</option>
                                  <option value="inActive">Inactive</option>
                                  <option value="pending">Pending</option>
                                  <option value="reject">Reject</option>
                                </select>
                                <has-error :form="form" field="status"></has-error>
                              </div> -->
                            </div>
                          </div>
                          <div class="row" v-if="empInfo.user">
                            <div class="col-md-6">
                              <div class="card-body box-profile">
                                <p><strong>Staff KYC Status </strong></p>
                                <div class="form-group">  
                                  <select
                                    v-model="form.status"
                                    name="status"
                                    class="form-control"
                                    :class="{
                                      'is-invalid': form.errors.has('status'),
                                    }"
                                    required
                                  >
                                    <option v-if="!form.status" selected value="">
                                      Select Status
                                    </option>
                                    <option value="active">Active</option>
                                    <option value="inActive">Inactive</option>
                                    <option value="pending">Pending</option>
                                  </select>
                                  <has-error :form="form" field="status"></has-error>
                                </div>
                                
                              </div>
                            </div>
                            <div class="col-md-6 col-xs-12" v-show="empInfo.user.mobileVerify != 'true'">
                              <p><strong>Staff Mobile Verify</strong></p>
                              <strong
                                ><input type="button" @click="sendOTP" class="btn btn-info btn-block" value="Send OTP To Mobile"></strong
                              ><br>
                              <div class="input-group input-group-sm">
                                <input
                                  v-model="form.otp"
                                  type="text"
                                  name="otp"
                                  placeholder="Please Enter OTP"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'otp'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="otp"
                                ></has-error>
                                  <span class="input-group-btn">
                                    <button type="button" @click="sendOTPVerify"  class="btn btn-success btn-flat"><strong>Verify OTP</strong></button>
                                  </span>
                                </div>
                            </div>
                          </div>
                        </div>
                        <!-- /.card-body -->
                      </div>
                    <!-- /.card -->
                    </div>
                  </div>
                    <!-- general form elements disabled -->
                    
                 
                  <!--/.col (right) -->
                </div>
                <div class="modal-footer text-center">
                  <button
                    v-show="!editMode"
                    type="submit"
                    class="btn btn-success"
                  >
                    SAVE
                  </button>
                  <button
                    v-show="editMode"
                    type="submit"
                    class="btn btn-success"
                  >
                    UPDATE
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                  >
                    CANCEL
                  </button>
                </div>
              </form>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
        <div class="modal fade" id="viewModal">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-aqua">
                
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Employee Profile</h4>
              </div>
              <div class="modal-body">
                <!-- right column -->
                <div class="row" v-if="empInfo.user">
                  <div class="col-md-3">
                    <!-- Profile Image -->
                    <div class="card card-primary card-outline">
                      <div class="card-body box-profile">
                        <div class="text-center">
                          <img
                            class="profile-user-img img-fluid img-circle"
                            :src= this.photo
                            alt="User profile picture"
                          />
                        </div>
                        <div  v-if="empInfo.status !== 'verified'" >
                          <input v-if="empInfo.photoStatus != 'true'" type="file" accept="image/*" @change="uploadPhoto($event)" id="file-input">
                        </div>
                        <h3 class="profile-username text-center">
                          {{ empInfo.user.name }}
                        </h3>

                        <p class="text-muted text-center">
                          {{ empInfo.designation.name }}
                        </p>

                        <ul class="list-group list-group-unbordered mb-3">
                          <li class="list-group-item">
                            <b>Employee Code</b>
                            <a class="float-right">{{ empInfo.user.code }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Branch</b>
                            <a class="float-right">{{ empInfo.branch.name }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Phone Number</b>
                            <a class="float-right">{{ empInfo.user.mobile }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>City</b>
                            <a class="float-right">{{ empInfo.city }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>DOB</b>
                            <a class="float-right">{{ empInfo.dob }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Joining Date</b>
                            <a class="float-right">{{ empInfo.joiningDate }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Status</b>
                            <a class="float-right">{{ empInfo.status }}</a>
                          </li>
                        </ul>

                        <a href="#" class="btn btn-primary btn-block"
                          ><b>Short Info</b></a
                        >
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  </div>
                  <!-- /.col -->
                  <div class="col-md-9">
                    <div class="card">
                      <div class="card-header p-2">
                        <ul class="nav nav-pills">
                          <li class="nav-item">
                            <a
                              class="nav-link active"
                              href="#activity"
                              data-toggle="tab"
                              >Profile</a
                            >
                          </li>
                          <li class="nav-item">
                            <a
                              class="nav-link"
                              href="#timeline"
                              data-toggle="tab"
                              >Bank Details</a
                            >
                          </li>
                          <li class="nav-item">
                            <a
                              class="nav-link"
                              href="#earnings"
                              data-toggle="tab"
                              >Earnings</a
                            >
                          </li>
                          <li class="nav-item">
                            <a
                              class="nav-link"
                              href="#deduction"
                              data-toggle="tab"
                              >Deduction</a
                            >
                          </li>
                          <li class="nav-item">
                            <a
                              class="nav-link"
                              href="#annualy"
                              data-toggle="tab"
                              >Annualy</a
                            >
                          </li>
                        </ul>
                      </div>
                      <!-- /.card-header -->
                      <div class="card-body">
                        <div class="tab-content">
                          <div class="tab-pane active" id="activity">
                            <!-- About Me Box -->
                            <div class="card card-primary">
                              <div class="card-header">
                                <h3 class="card-title">Profile Information</h3>
                              </div>
                              <!-- /.card-header -->
                              <div class="card-body">
                                <strong
                                  ><i class="fa fa-user mr-1"></i> Father
                                  Name</strong
                                >

                                <p class="text-muted">
                                  {{ empInfo.fatherName }}
                                </p>

                                <hr />

                                <strong
                                  ><i class="fas fa-map-marker-alt mr-1"></i>
                                  Address</strong
                                >

                                <p class="text-muted">
                                  {{ empInfo.address }}
                                </p>

                                <hr />

                                <strong
                                  ><i class="fas fa-map-marker-alt mr-1"></i>
                                  City</strong
                                >

                                <p class="text-muted">{{ empInfo.city }}</p>

                                <hr />
                                <strong
                                  ><i class="fas fa-map-marker-alt mr-1"></i>
                                  State</strong
                                >

                                <p class="text-muted">
                                  {{ empInfo.state.name }}
                                </p>

                                <hr />

                                <strong
                                  ><i class="far fa-file-alt mr-1"></i> Previous
                                  Experience</strong
                                >

                                <p class="text-muted">
                                  {{ empInfo.lastExperience }}
                                </p>
                              </div>
                              <!-- /.card-body -->
                            </div>
                            <!-- /.card -->
                          </div>
                          <!-- /.tab-pane -->
                          <div class="tab-pane" id="timeline">
                            <!-- The timeline -->
                            <div class="card card-primary">
                              <div class="card-header">
                                <h3 class="card-title">Bank Information</h3>
                              </div>
                              <!-- /.card-header -->
                              <div class="card-body">
                                <strong
                                  ><i class="fas fa-user mr-1"></i> Account
                                  Holder Name</strong
                                >

                                <p class="text-muted">
                                  {{ empInfo.accountHolderName }}
                                </p>

                                <hr />

                                <strong
                                  ><i class="fas fa-book mr-1"></i> Bank Account
                                  Number</strong
                                >

                                <p class="text-muted">
                                  {{ empInfo.accountNumber }}
                                </p>

                                <hr />

                                <strong
                                  ><i class="fas fa-map-marker-alt mr-1"></i
                                  >Bank Name & Branch Name & IFSC Code</strong
                                >

                                <p class="text-muted">
                                  <i v-if="empInfo.bank">{{ empInfo.bank.name }},</i>
                                  {{ empInfo.bank_branch }}, IFSC Code -
                                  {{ empInfo.ifsc }}
                                </p>

                                <hr />

                                <strong
                                  ><i class="fas fa-pencil-alt mr-1"></i>
                                  Pancard Number</strong
                                >

                                <p class="text-muted">
                                  <span class="tag tag-danger">{{
                                    empInfo.pan
                                  }}</span>
                                </p>

                                <hr />

                                <strong
                                  ><i class="fas fa-pencil-alt mr-1"></i> Adhar
                                  Card Number</strong
                                >

                                <p class="text-muted">{{ empInfo.aadhar }}</p>
                              </div>
                              <!-- /.card-body -->
                            </div>
                            <!-- /.card -->
                          </div>
                          <!-- /.tab-pane -->

                          <div class="tab-pane" id="earnings">
                            <div class="card card-primary">
                              <div class="card-header">
                                <h3 class="card-title">Earnings Details</h3>
                              </div>
                              <!-- /.card-header -->
                              <div class="card-body">
                                <strong
                                  ><i class="fa fa-rupee-sign mr-1"></i> Basic
                                  Salary (Annual)</strong
                                >

                                <p class="text-muted">
                                  {{ empInfo.basicSalary }}
                                </p>

                                <hr />

                                <strong
                                  ><i class="fa fa-rupee-sign mr-1"></i> Fixed
                                  Allowance</strong
                                >

                                <p class="text-muted">
                                  {{ empInfo.fixedAllowance }}
                                </p>

                                <hr />
                              </div>
                              <!-- /.card-body -->
                            </div>
                            <!-- /.card -->
                          </div>
                          <!-- /.tab-pane -->
                          <div class="tab-pane" id="deduction">
                            <!-- The timeline -->
                            <div class="card card-primary">
                              <div class="card-header">
                                <h3 class="card-title">Deduction Details</h3>
                              </div>
                              <!-- /.card-header -->
                              <div class="card-body">
                                <strong
                                  ><i class="fa fa-rupee-sign mr-1"></i> Fixed
                                  Deduction (in Month)</strong
                                >

                                <p class="text-muted">
                                  {{ empInfo.fixedDeduction }}
                                </p>

                                <hr />

                                <strong
                                  ><i class="fa fa-rupee-sign mr-1"></i> Income
                                  Tax (in Month)</strong
                                >

                                <p class="text-muted">
                                  {{ empInfo.incomeTax }}
                                </p>

                                <hr />

                                <strong
                                  ><i class="fa fa-pencil-alt mr-1"></i> Number
                                  of Month for Fixed Deduction</strong
                                >

                                <p class="text-muted">
                                  {{ empInfo.numberOfMonthForFixedDeduction }}
                                </p>

                                <hr />
                                <strong
                                  ><i class="fa fa-pencil-alt mr-1"></i> Number
                                  of Month Income Tax</strong
                                >

                                <p class="text-muted">
                                  {{ empInfo.numberOfMonthIncomeTax }}
                                </p>

                                <hr />
                              </div>
                              <!-- /.card-body -->
                            </div>
                            <!-- /.card -->
                          </div>
                          <!-- /.tab-pane -->
                          <div class="tab-pane" id="annualy">
                            <div class="card card-primary">
                              <div class="card-header">
                                <h3 class="card-title">Annualy Details</h3>
                              </div>
                              <!-- /.card-header -->
                              <div class="card-body">
                                <div class="row">
                                  <div class="col-md-6">
                                    <strong
                                      ><i class="fa fa-cash-register mr-1"></i>
                                      Sick Leave(Annualy)</strong
                                    >

                                    <p class="text-muted">
                                      {{ empInfo.sickLeave }}
                                    </p>

                                    <hr />

                                    <strong
                                      ><i class="fa fa-cash-register mr-1"></i>
                                      Previlage Leave</strong
                                    >

                                    <p class="text-muted">
                                      {{ empInfo.previlageLeave }}
                                    </p>

                                    <hr />
                                    <strong
                                      ><i class="fa fa-cash-register mr-1"></i>
                                      Maternity Leave</strong
                                    >

                                    <p class="text-muted">
                                      {{ empInfo.maternityLeave }}
                                    </p>

                                    <hr />
                                    <strong
                                      ><i class="fa fa-cash-register mr-1"></i>
                                      Paternity Leave</strong
                                    >

                                    <p class="text-muted">
                                      {{ empInfo.paternityLeave }}
                                    </p>

                                    <hr />
                                  </div>
                                  <div class="col-md-6">
                                    <strong
                                      ><i class="fa fa-cash-register mr-1"></i>
                                      Mandatory Leave</strong
                                    >

                                    <p class="text-muted">
                                      {{ empInfo.mandatoryLeave }}
                                    </p>

                                    <hr />

                                    <strong
                                      ><i class="fa fa-cash-register mr-1"></i>
                                      Extra Ordinary Leave</strong
                                    >

                                    <p class="text-muted">
                                      {{ empInfo.extraOrdinaryLeave }}
                                    </p>

                                    <hr />
                                    <strong
                                      ><i class="fa fa-cash-register mr-1"></i>
                                      Casual Leaves (Annually)</strong
                                    >

                                    <p class="text-muted">
                                      {{ empInfo.casualLeave }}
                                    </p>

                                    <hr />
                                  </div>
                                </div>
                              </div>
                              <!-- /.card-body -->
                            </div>
                            <!-- /.card -->
                          </div>
                          <!-- /.tab-pane -->
                        </div>
                        <!-- /.tab-content -->
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.nav-tabs-custom -->
                  </div>
                  <!-- /.col -->
                </div>
              </div>
              <div class="modal-footer text-center">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CLOSE
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
        <employeeidcard :empInfo="empInfo" :logo="logo" :getCompanyRecord="getCompanyRecord" :photo="photo"></employeeidcard>
        
  </div>
</template>

<script>
import employeeidcard from '../components/EmployeeIdCard.vue'
import GetBranch from '../../mixins/BranchRecords'
import { mapState } from 'vuex'
export default {
  name: 'Employee',
  computed: {
    ...mapState([
      'profile',
      'user'
    ])
  },
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 10,
      table_search: '',
      branches: [],
      branch: {},
      states: {},
      banks: {},
      designations: [],
      designation: {},
      roles: [],
      reasons: {},
      empInfo: {},
      logo: '',
      getCompanyRecord: {},
      photo: 'https://via.placeholder.com/100/FFFF00/000000?text=Photo',
      editMode: false,
      form: new Form({
        id: '',
        branch_id: '',
        role_id: '',
        name: '',
        alias: '',
        designation_id: '',
        mobile: '',
        phone: '',
        email: '',
        password: null,
        dob: '',
        fatherName: '',
        address: '',
        city: '',
        state_id: '',
        nationality: '',
        pin: '',
        joiningDate: new Date().toISOString().slice(0, 10),
        photo: '',
        lastExperience: '',
        accountHolderName: '',
        accountNumber: '',
        pan: '',
        panStatus: 'false',
        aadhar: '',
        aadharStatus: 'false',
        bank_branch: '',
        ifsc: '',
        bank_id: '',
        basicSalary: '',
        fixedDeduction: '',
        fixedAllowance: '',
        incomeTax: '',
        numberOfMonthForFixedDeduction: '',
        numberOfMonthIncomeTax: '',
        paternityLeave: '',
        maternityLeave: '',
        mandatoryLeave: '',
        extraOrdinaryLeave: '',
        casualLeave: '',
        sickLeave: '',
        previlageLeave: '',
        reason_id: '',
        otp: '',
        status: ''
        // errors: {errors: null}
        // errors:{ 'errors': { 'name': [ 'The name field is required' ], 'mobile': [ 'The mobile field is required' ], 'branch_id': [ 'The branch id field is required' ], 'designation_id': [ 'The designation id field is required.' ], 'state_id': [ 'The state id must be a number.' ], 'pin': [ 'The pin must be a number.', 'The pin must be 6 digits.' ], 'bank_id': [ 'The bank id must be a number.' ] } }
      }),
      // error:null,
      // columns: [
      //   {
      //     label: 'EMPLOYEE CODE',
      //     field: 'user.code'
      //   },
      //   {
      //     label: 'NAME',
      //     field: 'user.name'
      //   },
      //   {
      //     label: 'ALIAS',
      //     field: 'user.alias'
      //   },
      //   {
      //     label: 'EMAIL',
      //     field: 'user.email'
      //   },
      //   {
      //     label: 'DESIGNATION',
      //     field: 'designation.name'
      //   },

      //   {
      //     label: 'PHONE NUMBER',
      //     field: 'user.mobile'
      //   },
      //   {
      //     label: 'BRANCH',
      //     field: 'branch.name'
      //   },
      //   {
      //     label: 'ACTIONS',
      //     field: 'id',
      //     type: 'number'
      //   }
      // ],
      rows: []
    }
  },
  components: {
    employeeidcard
  },
  mixins: [GetBranch],
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    uploadPhoto (event) {
      const URL = 'staff/photo'
      let data = new FormData()
      data.append('user_id', this.empInfo.user_id)
      data.append('photo', event.target.files[0])
      let config = {
        header: {
          'Content-Type': 'image/png'
        }
      }
      this.$axios.post(
        URL,
        data,
        config
      ).then(
        response => {
          this.photo = this.$store.state.imageBaseUrl + this.empInfo.user_id + '/photo/' + response.data.photo.image_name
          Fire.$emit('AfterCreate')
          // console.log('image upload response ', response)
        }
      )
    },
    getRecordDesignationWise () {
      this.form.designation_id = ''
      if (this.designation) {
        this.form.designation_id = this.designation.id
      }
      this.changeFilter()
    },
    downloadExcel () {
      this.$axios
        .get('staff/export/csv', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Toast.fire({
            icon: 'success',
            title: 'Records Downloaded Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    branchRecordWithchangeFilter () {
      this.designations = []
      this.designation = {}
      this.form.designation_id = ''
      this.form.branch_id = ''
      this.loadDesignation()
      if (this.branch) {
        this.form.branch_id = this.branch.id
      }
      this.changeFilter()
    },
    newModal () {
      this.editMode = false
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
    },
    editModal (row) {
      this.editMode = true
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      this.form.email = row.user.email
      this.form.mobile = row.user.mobile
      this.form.name = row.user.name
      this.form.role_id = row.user.role_id
    },
    loginStaffStatus () {
      this.form.id = this.empInfo.id
      this.$axios
        .post('staff/staffstatus', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          Fire.$emit('AfterCreate')
          $('#loginStatus').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Record Update Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loginStatus (row) {
      $('#loginStatus').modal({backdrop: 'static', keyboard: false})
      this.form.reset()
      this.form.fill(row)
      this.form.status = row.user.status
      this.empInfo = row
    },
    verifyModal (row) {
      this.editMode = true
      $('#verifyModal').modal({backdrop: 'static', keyboard: false})
      this.form.reset()
      this.form.fill(row)
      this.form.email = row.user.email
      this.form.mobile = row.user.mobile
      this.form.name = row.user.name
      this.form.alias = row.user.alias
      this.form.role_id = row.user.role_id
      this.form.status = row.status
      this.empInfo = row
    },
    loadCompanyProfile () {
      let loader = this.$loading.show()
      this.$axios
        .get('settings', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.getCompanyRecord = data
          if (this.getCompanyRecord.logo != null) {
            this.logo = this.$store.state.imageBaseUrl + 'logo/' + this.getCompanyRecord.logo
          } else {
            alert('hello')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    sendOTP () {
      // alert(this.empInfo.user_id)
      this.form.id = this.empInfo.id
      this.$axios
        .post('staff/sendstaffotp', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          Toast.fire({
            icon: 'success',
            title: 'One Time Password Send Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    sendOTPVerify () {
      this.form.id = this.empInfo.id
      this.$axios
        .post('staff/verifystaff', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          Toast.fire({
            icon: 'success',
            title: 'Mobile Number Verify Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    viewModal (row) {
      this.editMode = false
      this.form.reset()
      $('#viewModal').modal({backdrop: 'static', keyboard: false})
      this.empInfo = row
      if (this.empInfo.photo != null) {
        this.photo = this.$store.state.imageBaseUrl + this.empInfo.user_id + '/photo/' + this.empInfo.photo
      } else {
        this.photo = 'https://via.placeholder.com/100/ffefda/000000?text=Photo'
      }
    },
    viewIdCardPrintModal (row) {
      this.editMode = false
      this.form.reset()
      this.empInfo = row
      if (this.empInfo.photo != null) {
        this.photo = this.$store.state.imageBaseUrl + this.empInfo.user_id + '/photo/' + this.empInfo.photo
      } else {
        this.photo = 'https://via.placeholder.com/100/ffefda/000000?text=Photo'
      }
      $('#viewIdCardPrintModal').modal({backdrop: 'static', keyboard: false})
    },
    createEmployee () {
      if (this.form.phone === '' || this.form.phone === null) {
        this.$delete(this.form, 'phone')
      }
      if (this.form.reason_id === '' || this.form.reason_id === null) {
        this.$delete(this.form, 'reason_id')
      }
      this.$axios
        .post('staff', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.form.reset()
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Staff Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    updateEmployee () {
      if (this.form.phone === '' || this.form.phone === null) {
        this.$delete(this.form, 'phone')
      }
      if (this.form.reason_id === '' || this.form.reason_id === null) {
        this.$delete(this.form, 'reason_id')
      }
      this.$axios
        .put('staff/' + this.form.id, this.form, {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then(() => {
          this.form.reset()
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Staff Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            this.form.errors.errors = error.response.data.error
            Toast.fire({ icon: 'error', title: this.form.errors.errors[Object.keys(this.form.errors.errors)[0]] })
          }.bind(this)
        )
    },
    changeFilter (page = null, pg = null) {
      var c = JSON.parse(localStorage.user)
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path
      } else {
        pageUrl += 'staff'
      }

      if (pg == null) {
        pageUrl += `?per_page=${this.per_page}`
      } else {
        pageUrl += `&per_page=${this.per_page}`
      }
      if (c.role.name !== 'Admin') {
        pageUrl += `&agent_id=${c.id}`
      }
      if (this.form.branch_id) {
        pageUrl += `&branch_id=${this.form.branch_id}`
      }
      if (this.form.designation_id) {
        pageUrl += `&designation_id=${this.form.designation_id}`
      }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          // console.log(data)
          this.rows = data.data.data
          this.pagination = data.data
        }).catch(function (error) { console.log(error) })
    },
    loadState () {
      this.$axios
        .get('state?all=all&status=active', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          this.states = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadDesignation () {
      this.$axios
        .get('designation?all=all&status=active', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          this.designations = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadRole () {
      this.$axios
        .get('role?all=all&status=active', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          this.roles = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadBank () {
      let loader = this.$loading.show()
      this.$axios
        .get('bank?all=all&status=active', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.banks = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadReason () {
      this.$axios
        .get('reason?all=all&status=active', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          this.reasons = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    }
  },
  created () {
    this.changeFilter()
    this.getBranch()
    this.loadState()
    this.loadDesignation()
    this.loadRole()
    this.loadBank()
    this.loadReason()
    this.loadCompanyProfile()
    Fire.$on('AfterCreate', () => {
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
  table.vgt-table {
  font-size:10px !important;
  border-collapse:collapse;
  background-color:#fff;
  width:100%;
  max-width:100%;
  table-layout:auto;
  border:1px solid #dcdfe6
  }
  .list-group-item {
    background-color: antiquewhite;
  }
  .content {
    padding: 0px;
  }
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>




// WEBPACK FOOTER //
// Employee.vue?1afadf3e